import styled from "styled-components";

export const USResponsibleGamingBox = styled.div`
        background-image: url("${props => props.theme.assets.images.regulation_specific.us.nj_rg_icon_svg.toString()}");
        height: 30px;
        width:90px;
        background-size: contain;
        background-repeat: no-repeat;
        
        @media ${({theme}) =>  theme.mediaQuery.sAndBelow} {
            height: 25px;
            width:70px;
        }
`